import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function EbikeIndustrySolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("ebike.title")}</title>
        <meta name="keywords" content={t("ebike.keywords")} />
        <meta name="description" content={t("ebike.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#1a3328]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/ebike-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_5.3%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#0f221a]/92 via-[#0f221a]/72 to-[#0f221a]/62" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("ebike.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("ebike.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("ebike.knowledgeBase.rootLabel")}
        rootColor="#059669"
        treeTranslationKey="ebike.knowledgeBase.tree"
        i18nPrefix="ebike.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="ebike"
        images={{
          painPoints: "/solutions/ebike-pain.jpeg",
          solutions: "/solutions/ebike-solutions.jpeg",
          cta: "/solutions/ebike-cta.jpeg",
        }}
        imagesPos={{
          painPoints: "50% 25%",
          solutions: "50% 30%",
          cta: "50% 22%",
        }}
      />
    </>
  );
}
